var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack192({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.43,10.22l-.26-4.29h.58l.1,2.12c0,.11,0,.38,0,.83,0,.12,0,.21,0,.26s0,.13,0,.29c.24-.48.41-.83.52-1l1.31-2.47h.59l.14,2.51c0,.29,0,.63,0,1,0-.1.1-.25.19-.45s.25-.54.32-.68L15.2,5.93h.59L13.6,10.22H13l-.15-2.6c0-.22,0-.49,0-.82-.12.27-.22.49-.3.64L11,10.22Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5,
    cy: 8,
    r: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack192);
export default __webpack_public_path__ + "static/media/Symbolpack_1_92.8a80fe5b357deea135e7eff4cb3aa024.svg";
export { ForwardRef as ReactComponent };